import DeviceGroupsPage from './DeviceGroupsPage';

export default DeviceGroupsPage;
